<template>
  <div class="location-message">
    <a
      :href="locationUrl"
      :style="`background-image: url(${imageUrl})`"
      class="map-link"
      target="_blank"/>
  </div>
</template>

<script>
import googleApiSignature from '@/helpers/googleApiSignature';
import { mapGetters } from 'vuex';

export default {
  name: 'LocationMessage',
  props: {
    location: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      googleApiKey: 'system/googleApiKey',
    }),
    /**
     * Determines if the location format is an old format that begins with "Location shared:"
     */
    isOldLocationFormat() {
      let oldLocationFormat = false;
      if (this.location.indexOf('Location shared') === 0) {
        oldLocationFormat = true;
      }

      return oldLocationFormat;
    },
    locationUrl() {
      let url = '';
      if (this.isOldLocationFormat) {
        url = this.location.replace('Location shared:', '').trim();
      } else {
        url = `https://www.google.com/maps/?q=${this.location}`;
      }
      return url;
      // Location shared:\nhttps://www.google.com/maps/?q=45.9078328,15.8806197"
    },
    coordinates() {
      const urlData = new URL(this.locationUrl);

      return urlData.searchParams.get('q');
    },
    imageUrl() {
      let url = '';
      if (this.isOldLocationFormat) {
        url = googleApiSignature(`https://maps.googleapis.com/maps/api/staticmap?zoom=15&size=220x190&scale=1&language=en&markers=color:0x3d8bfc|${this.coordinates}&key=${this.googleApiKey}&style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e`);
      } else {
        url = googleApiSignature(`https://maps.googleapis.com/maps/api/staticmap?zoom=15&size=220x190&scale=1&language=en&markers=color:0x3d8bfc|${this.location}&key=${this.googleApiKey}&style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e`);
      }

      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.location-message {
  position: relative;
  background: $lightGray none repeat scroll 0 0;
  border-radius: 20px;
  padding: 3px;

  .map-link {
    display: block;
    border-radius: 17px;
    overflow: hidden;
    width: 220px;
    height: 150px;
    background-size: cover;
    background-position: 50% 50%;
  }
}
</style>
